import { TextDirective } from 'mdast-util-directive'
import { Plugin } from 'unified'
import { visit } from 'unist-util-visit'

export const iconRemarkPlugin: Plugin = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (node.type !== 'textDirective') return
      const directiveNode = node as TextDirective
      if (directiveNode.name !== 'icon') return

      const data = directiveNode.data || (directiveNode.data = {})
      data.hName = directiveNode.name
      data.hProperties = { ...directiveNode.attributes }
    })
  }
}

export const spanRemarkPlugin: Plugin = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (node.type !== 'textDirective') return
      const directiveNode = node as TextDirective
      if (directiveNode.name !== 'span') return

      const data = directiveNode.data || (directiveNode.data = {})
      data.hName = directiveNode.name
      data.hProperties = { ...directiveNode.attributes }
    })
  }
}
